/**
 * services/leads.js
 * Управление лидами: создание и обновление.
 */
import { apiService } from './api';

export const leadsService = {
  /**
   * Собирает стандартный payload лида.
   * extraFields дополняют тот же объект (например, { guide_requested: true }).
   */
  async createLead(userData, extraFields = {}) {
    // Защита от undefined — leadData и interests могут не существовать
    const leadData  = userData?.leadData  || {};
    const interests = userData?.interests || {};

    const payload = {
      uuid:                 userData?.id      || undefined,
      name:                 leadData.name     || undefined,
      company:              leadData.company  || undefined,
      email:                leadData.email    || undefined,
      phone:                leadData.phone    || undefined,
      industry:             interests.industry   || undefined,
      region:               interests.geography  || undefined,
      participation_goal:   interests.goal       || undefined,
      participation_format: interests.format     || undefined,
      scenario:             interests.scenario   || undefined,
      channel:              userData?.channel    || undefined,
      language:             userData?.language   || undefined,
      page_url:             window?.location?.href || undefined,
      message:              leadData.message     || undefined,
      ...extraFields,
    };

    // Убираем undefined-значения чтобы не засорять запрос
    Object.keys(payload).forEach(k => {
      if (payload[k] === undefined) delete payload[k];
    });

    const result = await apiService.post('/leads', payload);
    return result;
  },
};
